import type { CardTemplateDocument } from "@private-fiction/story-core";

/** The legacy layout and full view often contain the same large tree. Keep one copy on the wire. */
export function compactTemplatePayload(template: CardTemplateDocument): CardTemplateDocument {
  if (!template.layouts?.full || JSON.stringify(template.layouts.full) !== JSON.stringify(template.layout)) return template;
  const { full: _full, ...layouts } = template.layouts;
  return { ...template, layouts };
}
export function compactStoryPayload(payload: Record<string, unknown>): Record<string, unknown> {
  return Array.isArray(payload.cardTemplates) ? { ...payload, cardTemplates: (payload.cardTemplates as CardTemplateDocument[]).map(compactTemplatePayload) } : payload;
}
